import React from 'react'
import ActivityIndicator from './ActivityIndicator'

const LoadingComponent = () => (
    <div className='loading-view'>
        <ActivityIndicator />
    </div>
)

export default LoadingComponent